/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S3_BodyInputs */

const en_fc_tut_s3_body = /** @type {(inputs: Fc_Tut_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to Import, or drag files straight into the Project panel. FilmCraft reads MP4/MOV, MKV/WebM and AVI video, common audio (AAC, MP3, WAV, FLAC) and stills (PNG, JPEG, WebP, TIFF). Organize clips into bins as you go.`)
};

/**
* | output |
* | --- |
* | "Switch to Import, or drag files straight into the Project panel. FilmCraft reads MP4/MOV, MKV/WebM and AVI video, common audio (AAC, MP3, WAV, FLAC) and stil..." |
*
* @param {Fc_Tut_S3_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s3_body = /** @type {((inputs?: Fc_Tut_S3_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S3_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s3_body(inputs)
});
export { fc_tut_s3_body as "fc.tut.s3.body" }